import { Component, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, } from '@angular/forms';
import { Alert, AlertsService, BroadcastService, I18NService, UserService } from '@socrates/socrates-shared';
import { User } from '@socrates/common';

@Component({
	selector: 'profile-modal',
	styleUrls: ['./profileModal.component.css'],
	templateUrl: './profileModal.component.html',
	standalone: false,
})
export class ProfileModalComponent {
	private _errorMessage: string;
	private _profileForm: FormGroup;
	private _submitted = false;
	private _submitting: boolean;
	private _placeholders: any;

	private user: User;

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private broadcastService: BroadcastService,
		private formBuilder: FormBuilder
	) {
		this.user = new User(this.userService.getUser().originalJson);

		this._profileForm = this.formBuilder.group(
		{
			firstName: [ this.user.firstName, [ Validators.required, ] ],
			lastName: [ this.user.lastName, [ Validators.required, ] ],
			email: [ this.user.username, [ Validators.required, Validators.email, ] ],
		},
		{ });

		this._placeholders = {
			firstName: I18NService.getMessage('dashboard.profile.placeholders.firstName'),
			lastName:  I18NService.getMessage('dashboard.profile.placeholders.lastName'),
			emailAddr: I18NService.getMessage('dashboard.profile.placeholders.emailAddr'),
		};
	}

	async onSubmit(): Promise<void> {
		this._submitting = true;
		this.user.username = this._profileForm.controls.email.value as string;
		this.user.firstName = this._profileForm.controls.firstName.value as string;
		this.user.lastName = this._profileForm.controls.lastName.value as string;

		try {
			const user: User = await this.userService.updateOwnUser(this.user);
			this._submitting = false;
			this.broadcastService.broadcast('modalService', { saved: true, user });
		} catch {
			this._submitting = false;
			this._errorMessage = I18NService.getMessage('dashboard.profile.errorMsgs.serverError');
		}
	}

	onReset(): void {
		this._profileForm.reset({
			firstName: this.user.firstName,
			lastName: this.user.lastName,
			email: this.user.username,
		});
		this.user = new User(this.userService.getUser().originalJson);
		this._submitted = false;
	}

	onCancel(): void {
		this.broadcastService.broadcast('modalService', { saved: false });
	}

	get errorMessage(): string {
		return this._errorMessage;
	}

	get formControls() {
		return this._profileForm.controls;
	}

	get profileForm(): FormGroup {
		return this._profileForm;
	}

	set profileForm(newProfileForm: FormGroup) {
		this._profileForm = newProfileForm;
	}

	get submitted(): boolean {
		return this._submitted;
	}

	get placeholders(): any {
		return this._placeholders;
	}

	get submitting(): boolean {
		return this._submitting;
	}
}
